import { log } from 'log';
import { showFreeSpin2BonusPopupAction } from 'js/components/popups/FreeSpin2BonusPopup/actions';

export const actionShowDialog2Info = async ({ actionId, actionInfo }, { syncClose }) => {
    const { dialogData } = actionInfo;
    const { dialogId, dialogParameters } = dialogData;
    const { playType } = dialogParameters;

    switch (playType) {
        case 'freespins2': {
            const { message, showGamesList, betConfigurations, gameCodeNames } = dialogParameters;

            return showFreeSpin2BonusPopupAction({
                id: actionId,
                message,
                betConfigurations,
                gameCodeNames,
                showGamesList,
                dialogId,
                onClose: () => syncClose(actionId)
            });
        }

        default:
            break;
    }

    log('error', 'Unsupported actionShowDialog2Info', actionInfo);
    return null;
};
